import { useQuery } from "@tanstack/react-query";
import { api, type S } from "@/shared/api/client";
import { useMe } from "@/shared/lib/session";

export function useRequestCounts() {
  const { data: me } = useMe();
  return useQuery({
    queryKey: ["/v1/requests", "counts"],
    queryFn: () => api.get<S["RequestsCounts"]>("/v1/requests/counts"),
    enabled: !!me && !!me.tenant.modules?.includes("requests"),
    refetchInterval: 60_000,
  });
}
